<template>
    <div class="table-box">
        <Table :columns="columns" :data="all_resmg.body" ref="table"></Table>
        <div  class="page-box" v-if="all_resmg.page">
            <Page show-sizer
                  show-total
                  :page-size="all_resmg.page.page_size"
                  :current="all_resmg.page.current"
                  :total="all_resmg.page.count"
                  @on-change="currentPage"
                  @on-page-size-change="pageSizeChange"
            />
        </div>
        <Modal
        v-model="editModel"
        title="状态修改"
        width="400"
        @on-ok="editOk"
        >
            <p>
                <span>状态</span>
                <Select v-model="change_status" style="width: 200px;margin-left: 15px" >
                    <Option :value="1">待审核</Option>
                    <Option :value="2">已通过</Option>
                    <Option :value="3">已拒绝</Option>
                </Select>
            </p>
        </Modal>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: "all",
        props: {
            res_status: Number
        },
        data(){
            return{
                page_num:0,
                page_size:20,
                editModel:false,
                change_status:null,
                edit_id:null,
                columns: [
                    {
                        title:'ID',
                        key:'id',
                        sortable: true,
                        width:80
                    },
                    {
                        title:'资源名称',
                        key:'res_name'
                    },
                    {
                        title:'分享人',
                        key:'shared_name'
                    },
                    {
                        title:'分享时间',
                        key:'share_time',
                        sortable: true
                    },
                    {
                        title:'状态',
                        key:'res_status',
                        filters: [
                            {
                                label: '已通过',
                                value: 2
                            },
                            {
                                label: '待审核',
                                value: 1
                            },
                            {
                                label: '已拒绝',
                                value: 3
                            }
                        ],
                        filterMultiple: false,
                        filterMethod (value, row) {
                            return row.res_status == value
                        },
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, this.resStatus(params.row.res_status))
                            ]);
                        }
                    },
                    {
                        title:'操作',
                        key:'last',
                        sortable: true,
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.editRow(params.row)
                                        }
                                    }
                                }, '审核'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.delRow(params.row)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
            }
        },
        computed: {
            ...mapState({
                all_resmg:state => state.resourceManage.all_resmg,
            }),

        },
        methods: {
            ...mapActions({
                getResmg: 'resourceManage/getResmg',
                delResmg: 'resourceManage/delResmg',
                editResmg: 'resourceManage/editResmg'
            }),
            resStatus(data){
                switch(data){
                    case 1:
                        return '待审核'
                    case 2:
                        return '已通过'
                    case 3:
                        return '已拒绝'
                }
            },
            currentPage(num){
                this.page_num = num
                this.initResmg()
            },
            pageSizeChange(size){
                this.page_size = size
                this.initResmg()
            },
            delRow(row){
                let _this = this
                this.$Modal.confirm({
                    title: '删除资源',
                    content: `确认要删除资源<b style="color: #2b85e4">${row.res_name}</b>吗！`,
                    cancelText: '取消',
                    onOk:function(){
                        _this.delResmg({
                            res_id:row.id,
                            callback:res =>{
                                _this.$Message.success('删除成功');
                                _this.initResmg()
                            },
                            err:res =>{
                                _this.$Message.error(res.status.message);
                            }
                        })
                    }

                })
            },
            editRow(row){
                this.edit_id = row.id
                this.editModel = true
            },
            editOk(){
                let _this = this
                this.editResmg({
                    res_id:_this.edit_id,
                    status:_this.change_status,
                    callback:res =>{
                        _this.$Message.success('状态修改成功');
                        _this.initResmg()
                    },
                    err:res =>{
                        _this.$Message.error(res.status.message);
                    }
                })
            },
            initResmg(){
                let _this = this
                this.getResmg({
                    page_num:_this.page_num,
                    page_size:_this.page_size,
                    status:_this.res_status
                })
            }
        },
        mounted () {
            this.initResmg()
        },
    }
</script>

<style scoped lang="less">
    @import "../../style/index";
</style>
